import axios from 'axios'
import { toast } from 'react-toastify'

class CampaignApiService {
    constructor() {
        this.baseURL = process.env.REACT_APP_API_URL
        this.token = localStorage.getItem('kt-auth-react-v.api_token')
    }

    getAuthHeaders() {
        return { Authorization: ` ${this.token}` }
    }

    async makeApiCall(method, url, data = null, confirmMessage = null) {
        if (confirmMessage && !window.confirm(confirmMessage)) {
            return false
        }

        try {
            const config = { headers: this.getAuthHeaders() }
            let response

            switch (method) {
                case 'GET':
                    response = await axios.get(url, config)
                    break
                case 'POST':
                    response = await axios.post(url, data, config)
                    break
                case 'PATCH':
                    response = await axios.patch(url, data, config)
                    break
                case 'DELETE':
                    response = await axios.delete(url, config)
                    break
                default:
                    throw new Error('Invalid HTTP method')
            }

            if (response.data.message) {
                toast.success(response.data.message)
            }
            return response.data
        } catch (error) {
            console.error('API Error:', error)
            toast.error(error.response.data.message || 'Something went wrong')
            return false
        }
    }

    async getCampaigns(searchQuery, source, is_deleted, offset, limit) {
        const url = `${this.baseURL}/campaign?searchQuery=${searchQuery}&source=${source}&is_deleted=${is_deleted}&offset=${offset}&limit=${limit}`
        return await axios.get(url, { headers: this.getAuthHeaders() })
    }

    async createCampaign(data) {
        return await this.makeApiCall('POST', `${this.baseURL}/campaign`, data)
    }

    async updateCampaign(id, data) {
        return await this.makeApiCall('PATCH', `${this.baseURL}/campaign/${id}`, data)
    }

    async enableCampaign(id) {
        return await this.makeApiCall(
            'PATCH',
            `${this.baseURL}/campaign/${id}/enable`,
            `Are you sure you want to enable this campaign?`,
        )
    }

    async deleteCampaign(id) {
        return await this.makeApiCall(
            'DELETE',
            `${this.baseURL}/campaign/${id}`,
            null,
            'Are you sure you want to delete this campaign?',
        )
    }
}

export const campaignApiService = new CampaignApiService()
